/**
 * abilityVfxDisintegrate — Annie Q Disintegrate fiery target burst (SP-13).
 */
export function buildDisintegrate(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.38 * (spec.scale || 0.95);
  const orange = mat(THREE, spec.color || 0xfb923c, 0.92);
  const gold = mat(THREE, 0xfbbf24, 0.95);
  const red = mat(THREE, 0xdc2626, 0.9);
  addCoreAndFlare(THREE, group, s, orange, gold);
  addFlameSpikes(THREE, group, s, orange, red);
  addEmbers(THREE, group, s, gold, red);
  addImpactRing(THREE, group, s, orange);
  group.userData = { shape: 'disintegrate' };
  return group;
}

function addCoreAndFlare(THREE, group, s, orange, gold) {
  group.add(new THREE.Mesh(new THREE.SphereGeometry(s, 12, 12), orange));
  const core = new THREE.Mesh(new THREE.SphereGeometry(s * 0.45, 10, 10), gold);
  core.position.y = 0.15 * s;
  group.add(core);
  const flare = new THREE.Mesh(
    new THREE.ConeGeometry(s * 0.55, s * 1.1, 6).rotateX(Math.PI / 2),
    gold
  );
  flare.position.set(0, 0.2 * s, -s * 0.5);
  group.add(flare);
}

function addFlameSpikes(THREE, group, s, orange, red) {
  for (let i = 0; i < 5; i += 1) {
    const a = (Math.PI * 2 / 5) * i;
    const spike = new THREE.Mesh(new THREE.ConeGeometry(0.1 * s, 0.5 * s, 5), red);
    spike.position.set(Math.cos(a) * s * 0.55, 0.25 * s, Math.sin(a) * s * 0.55);
    if (!spike.rotation) spike.rotation = { x: 0, y: 0 };
    spike.rotation.x = -Math.PI / 3;
    spike.rotation.y = a;
    group.add(spike);
    const tongue = new THREE.Mesh(new THREE.BoxGeometry(0.06 * s, 0.35 * s, 0.06 * s), orange);
    tongue.position.set(Math.cos(a) * s * 0.35, 0.18 * s, Math.sin(a) * s * 0.35);
    group.add(tongue);
  }
}

function addEmbers(THREE, group, s, gold, red) {
  for (let i = 0; i < 4; i += 1) {
    const a = (Math.PI / 2) * i + 0.4;
    const ember = new THREE.Mesh(new THREE.SphereGeometry(0.07 * s, 8, 8), gold);
    ember.position.set(Math.cos(a) * s * 0.9, 0.35 * s, Math.sin(a) * s * 0.9);
    group.add(ember);
    const spark = new THREE.Mesh(new THREE.BoxGeometry(0.05 * s, 0.05 * s, 0.2 * s), red);
    spark.position.set(Math.cos(a) * s * 0.7, 0.5 * s, Math.sin(a) * s * 0.7);
    group.add(spark);
  }
}

function addImpactRing(THREE, group, s, orange) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.55, s * 1.15, 20).rotateX(-Math.PI / 2),
    orange
  );
  ring.position.y = 0.04;
  group.add(ring);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
